module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "commandsyncer"
  }, [_c('Loading', {
    attrs: {
      "show": !_vm.logs.length
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Synkronisering")]), _vm._v(" "), _c('h2', [_vm._v("Boenden")]), _vm._v(" "), _c('button', {
    staticClass: "btn small",
    on: {
      "click": function($event) {
        return _vm.sync('sync:accomodations', {
          accomodationId: ['accomodation', 'Boende-ID i databas eller slug', '']
        }, [
          '--update'
        ])
      }
    }
  }, [_vm._v("\n    Boenden\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn small",
    on: {
      "click": function($event) {
        return _vm.sync('sync:accomodations', {}, [
          '--only-check-new'
        ])
      }
    }
  }, [_vm._v("\n    Endast nya boenden\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn small",
    on: {
      "click": function($event) {
        return _vm.sync('sync:accomodationprices', {
          accomodationId: ['accomodation', 'Boende-ID i databas eller slug', ''],
          '--winter-prices': ['switch', 'VINTER: priser', true],
          '--winter-day-prices': ['switch', 'VINTER: dygnspriser', true],
          '--winter-availability': ['switch', 'VINTER: tillgänglighet', true],
          '--price-codes': ['text-readonly', 'Priskoder', 'all'],
          '--summer-prices': ['switch', 'SOMMAR: priser'],
          '--summer-availability': ['switch', 'SOMMAR: tillgänglighet'],
          '--next-winter-prices': ['switch', 'NÄSTA VINTER: priser', false, !_vm.SITE_CONFIG.next_season.winter.is_active],
          '--next-winter-availability': ['switch', 'NÄSTA VINTER: tillgänglighet', false, !_vm.SITE_CONFIG.next_season.winter.is_active],
        }, [])
      }
    }
  }, [_vm._v("\n    Boendepriser\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn small",
    on: {
      "click": function($event) {
        return _vm.sync('sync:accomodation_show_web')
      }
    }
  }, [_vm._v("\n    Boenden: visa på webb\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn small",
    on: {
      "click": function($event) {
        return _vm.sync('sync:accomodations_to_web')
      }
    }
  }, [_vm._v("\n    Till Wordpress\n  ")]), _vm._v(" "), _c('h2', [_vm._v("Produkter")]), _vm._v(" "), _c('button', {
    staticClass: "btn small",
    on: {
      "click": function($event) {
        return _vm.sync('sync:skiletting_products')
      }
    }
  }, [_vm._v("\n    Skidhyra\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn small",
    on: {
      "click": function($event) {
        return _vm.sync('sync:skipass')
      }
    }
  }, [_vm._v("\n    Liftkort\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn small",
    on: {
      "click": function($event) {
        return _vm.sync('sync:skischool')
      }
    }
  }, [_vm._v("\n    Skidskola\n  ")]), _vm._v(" "), _c('h2', [_vm._v("Övrigt")]), _vm._v(" "), _c('button', {
    staticClass: "btn small",
    on: {
      "click": function($event) {
        return _vm.sync('sync:promotion_codes')
      }
    }
  }, [_vm._v("\n    Kampanjkoder\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn small",
    on: {
      "click": function($event) {
        return _vm.sync('cache:prefetch')
      }
    }
  }, [_vm._v("\n    Re-cache\n  ")]), _vm._v(" "), _vm._v("\n\n      \n  "), _c('hr'), _vm._v("\n      \n\n  Visar de " + _vm._s(_vm.count) + " senaste\n\n  "), _c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.logs), function(log) {
    return _c('tbody', [_c('tr', {
      class: {
        success: log.success, failed: log.failed
      }
    }, [_c('td', [(log.success) ? _c('icon', {
      attrs: {
        "name": "punklista-check",
        "scale": 1
      }
    }) : _vm._e(), _vm._v(" "), (log.failed) ? _c('icon', {
      attrs: {
        "name": "error",
        "scale": 1
      }
    }) : _vm._e(), _vm._v(" "), (log.failed) ? _c('span', [_c('br'), _vm._v("Fel")]) : _vm._e(), _vm._v(" "), (!log.success && !log.failed) ? _c('span', [_vm._v("Kör...")]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s((log.done || 0) + '/' + (log.total_count || 1)) + "\n        ")]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s((Math.min((((log.done || 0) / (log.total_count || 1)) * 100), 100).toLocaleString())) + "%\n        ")]), _vm._v(" "), _c('td', [_c('span', {
      staticStyle: {
        "white-space": "pre"
      }
    }, [_vm._v(_vm._s(_vm.moment(log.created_at).format('D MMM')))])]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(_vm.moment(log.created_at).format('HH:mm:ss')) + "\n        ")]), _vm._v(" "), (log.success || log.failed) ? _c('td', [_vm._v("\n          " + _vm._s(_vm.moment(log.updated_at).format('HH:mm:ss')) + "\n        ")]) : _c('td', {
      attrs: {
        "title": log.time_remaining + ' sekunder'
      }
    }, [(log.time_remaining) ? _c('span', [_vm._v(_vm._s(_vm.moment().add(Math.abs(log.time_remaining), 'seconds').fromNow()))]) : _c('span', [_vm._v("nu")])]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(log.name))]), _c('br'), _vm._v(" "), _c('i', {
      domProps: {
        "innerHTML": _vm._s(log.arguments)
      }
    })])])])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "btn small",
    on: {
      "click": function($event) {
        return _vm.getList(true)
      }
    }
  }, [_vm._v("Fler")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Skapad")]), _vm._v(" "), _c('th', [_vm._v("ETA/Klart")]), _vm._v(" "), _c('th', [_vm._v("Jobb")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fcd0dc4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/CommandSyncer.vue
// module id = 900
// module chunks = 0